import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Banner from './Banner/Banner';
import Belief from './Belief/Belief';
import Product from './Product/Product';
import Partners from './Partners/Partners';
import History from './History/History';

import { useSetRecoilState } from 'recoil';
import { isHeaderBlackState } from '../../store/atoms';

import styled from 'styled-components';

export default function Home() {
  const setIsHeaderBlack = useSetRecoilState(isHeaderBlackState);

  const handleScroll = () => {
    const { scrollTop } = document.documentElement;
    if (scrollTop > 0) setIsHeaderBlack(false);
    if (scrollTop === 0) setIsHeaderBlack(true);
  };

  useEffect(() => {
    setIsHeaderBlack(true);
    window.scrollTo(0, 0);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <meta
          property="og:description"
          content="모두를 위한 현명한 투자, 인텔리퀀트"
        />
        <meta
          name="description"
          content="모두를 위한 현명한 투자, 인텔리퀀트"
        />
      </Helmet>

      <StyledHome>
        <Banner />
        <Belief />
        <Product />
        <Partners />
        <History />
      </StyledHome>
    </>
  );
}

const StyledHome = styled.section`
  width: 100%;
  height: 100%;
  flex: 1;
  margin-top: 83px;

  ${({ theme }) => theme.mobile`
    margin-top: 0;
  `}
`;
